const Earth = `${process.env.PUBLIC_URL}/circle.png`;
const Logo = `${process.env.PUBLIC_URL}/logo-deloitte.svg`;
export { Earth, Logo };